/**
 * Parent-facing naming for the field trip meal (Sheila, 2026-10-06): every
 * item on an ELECTED bagged menu reads "Field Trip Meal: <name>" wherever a
 * household sees it — the day sheet, the picker, the cart.
 */
export const FIELD_TRIP_MEAL_PREFIX = 'Field Trip Meal: '

/** Idempotent, so an already-prefixed name is never doubled. */
export function fieldTripMealTitle(name: string): string {
  return name.startsWith(FIELD_TRIP_MEAL_PREFIX) ? name : `${FIELD_TRIP_MEAL_PREFIX}${name}`
}
